// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__YwY_a","checkVisible":"checkbox_checkVisible__glwUq","label":"checkbox_label__CTKoe","message":"checkbox_message__btT6v"};